<template>
  <div class="main-cont" style="height:100%;">
    <div class="common-header" style="height:65px;">
      <div class="center-cont clearfix">
        <div class="left logo-cont" @click="goIndex">
          <img src="../assets/logo/main-logo.png" alt />
        </div>
        <el-menu class="left" :default-active="activeIndex" mode="horizontal" text-color="#fff"
          active-text-color="#0d8fe3">
          <el-menu-item index="0">
            <a href="/main" class="link-css">首页</a>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">大湾区产业地图</template>
            <el-menu-item index="1-1">
              <a @click="
                GetCode(
                  $config.Cydt.systemCode,
                  $config.Cydt.pageUrl + '/macrographydata'
                )
                " class="small-link">宏观数据</a>
            </el-menu-item>
            <el-menu-item index="1-2">
              <a @click="
                GetCode(
                  $config.Cydt.systemCode,
                  $config.Cydt.pageUrl + '/datamap'
                )
                " class="small-link">数据地图</a>
            </el-menu-item>
            <el-menu-item index="1-3">
              <a @click="
                GetCode(
                  $config.Cydt.systemCode,
                  $config.Cydt.pageUrl + '/heatmap'
                )
                " class="small-link">热力图</a>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="2">
            <a @click="
              GetCode(
                $config.Yqk.systemCode,
                $config.Yqk.pageUrl + '/gbaparkstore'
              )
              " class="link-css">大湾区园区库</a>
          </el-menu-item>
          <el-menu-item index="3">
            <a @click="
              GetCode(
                $config.Dp.systemCode,
                $config.Dp.pageUrl + '/parkbigscreen'
              )
              " class="link-css">园区大屏</a>
          </el-menu-item>

          <el-menu-item index="4">
            <a href="http://zs.hezongshuju.com" target="_blank" class="link-css">招商智囊</a>
          </el-menu-item>

          <el-menu-item index="5">
            <a href="http://8.129.78.28:8009" target="_blank" class="link-css">园区空间资管</a>
          </el-menu-item>
          <!-- <el-menu-item index="4">
                    <a href="http://localhost:8094" class="link-css">行业信息</a>
                </el-menu-item> -->
        </el-menu>
        <div class="right avatar-cont">
          <div class="btn-panel" v-if="!parkToken">
            <button type="button" class="login" @click="selfLogin">
              登 录
            </button>
            <!-- <button type="button" class="m-l-20 register" @click="register">注 册</button> -->
          </div>
          <el-dropdown trigger="click" v-else @command="handleCommand">
            <span class="el-dropdown-link p-l-10 p-r-10">
              <!-- <el-avatar :size="28" :src="userInfo.userIcon" class="m-r-5"></el-avatar> -->
              <el-avatar :size="'small'" :src="imgPath"></el-avatar>
              {{ userInfo.name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="personal">个人中心</el-dropdown-item>
              <el-dropdown-item command="exit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <el-main>
      <router-view></router-view>
    </el-main>
    <el-dialog v-if="loginDialog" title="" :visible.sync="loginDialog" center width="500px" top="8vh"
      :close-on-click-modal="false">
      <div class="center-cont-bg1 clearfix" :element-loading-text="loadText" v-loading="isLoading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="toggle-title">
          <div class="item" :class="phoneLoginFlag ? 'active' : ''" @click="toggleLogin(1)">
            短信登录
          </div>
          <div class="item" :class="loginFlag ? 'active' : ''" @click="toggleLogin(2)">
            账号登录
          </div>
        </div>
        <div v-if="phoneLoginFlag" class="center-cont">
          <el-form ref="phoneLoginForm" status-icon :model="phoneLoginForm" :rules="rules" style="padding:0;">
            <el-form-item prop="phone">
              <el-input placeholder="请输入手机号" prefix-icon="iconfont icon-dianhua" v-model.number="phoneLoginForm.phone"
                autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item prop="verificationCode">
              <el-input placeholder="请输入验证码" prefix-icon="iconfont icon-yanzhengma2"
                v-model="phoneLoginForm.verificationCode" style="width:68%;"></el-input>
              <el-button type="primary" :disabled="(disabled = !show)" class="vercode">
                <span v-show="show" @click.stop="getVeriCode">获取验证码</span>
                <span v-show="!show" class="count" style="color: #fff;">{{ count }} s</span>
              </el-button>
            </el-form-item>
            <el-row>
              <el-button type="primary" @click="submitForm('phoneLoginForm')" class="m-t-10">登 录</el-button>
            </el-row>
            <!-- <el-row>
                        <el-button type="primary" plain @click="register()" class="m-t-20">注 册</el-button>
                    </el-row>
                    <el-row class="center grey">
                        还没有注册账号？
                    </el-row> -->
          </el-form>
        </div>
        <div v-if="loginFlag" class="center-cont">
          <el-form ref="loginForm" :model="loginForm" :rules="rules">
            <el-form-item prop="name">
              <el-input v-model="loginForm.name" prefix-icon="iconfont icon-zhanghao" placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item prop="pwd">
              <el-input v-model="loginForm.pwd" prefix-icon="iconfont icon-mimasuo" placeholder="请输入密码"
                show-password></el-input>
            </el-form-item>
            <div class="clearfix save-cont">
              <div class="left">
                <el-checkbox v-model="loginForm.saveme">记住我</el-checkbox>
              </div>
              <div class="right">
                <el-link type="primary" :underline="false" @click="forgetPass">忘记密码？</el-link>
              </div>
            </div>
            <el-row class="m-t-20">
              <el-button type="primary" @click="getLogin">登录</el-button>
            </el-row>
            <!-- <el-row class="m-t-20">
                        <el-button type="primary" plain @click="getLogin">注册</el-button>
                    </el-row>
                    <el-row class="center grey">
                        还没有注册账号？
                    </el-row> -->
          </el-form>
        </div>
        <div v-if="forgetPassFlag" class="center-cont">
          <h5>忘记密码</h5>
          <div class="form-cont reset-cont">
            <el-form ref="forgetForm" status-icon :model="forgetForm" :rules="rules" style="padding:0;">
              <el-form-item prop="phone">
                <el-input placeholder="请输入手机号" prefix-icon="iconfont icon-dianhua" v-model.number="forgetForm.phone"
                  autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item prop="verificationCode">
                <el-input placeholder="请输入验证码" prefix-icon="iconfont icon-yanzhengma2"
                  v-model="forgetForm.verificationCode" style="width:62%;"></el-input>
                <el-button type="primary" :disabled="(disabled = !show)" class="vercode">
                  <span v-show="show" @click.stop="getVeriCode">获取验证码</span>
                  <span v-show="!show" class="count" style="color: #fff;">{{ count }} s</span>
                </el-button>
              </el-form-item>
              <el-form-item prop="newpassWord">
                <el-input type="passWord" placeholder="设置新密码" prefix-icon="iconfont icon-mimasuo"
                  v-model="forgetForm.newpassWord"></el-input>
              </el-form-item>
              <el-form-item prop="confirmpassWord">
                <el-input type="passWord" placeholder="请再次输入新密码" prefix-icon="iconfont icon-mimasuo"
                  v-model="forgetForm.confirmpassWord"></el-input>
              </el-form-item>
              <!-- <input name="save" type="checkbox" id="saveBox" v-model="saveName" @click="isSave" :checked="this.saveName" />
              <label for="saveBox">记住用户名和密码</label>-->
              <el-row class="m-t-10 m-b-10">
                <el-link type="primary" :underline="false" @click="returnLogin">已有账号？返回登录</el-link>
              </el-row>
              <el-row>
                <el-button type="primary" @click="updatePass('forgetForm')">完成</el-button>
              </el-row>
            </el-form>
          </div>
        </div>
        <div v-if="resetPassFlag" class="center-cont">
          <h5>设置密码</h5>
          <div class="form-cont">
            <el-form ref="setForm" status-icon :model="setForm" :rules="rules" style="padding:0;">
              <el-form-item prop="newpassWord">
                <el-input type="passWord" placeholder="设置新密码" prefix-icon="iconfont icon-mimasuo"
                  v-model="setForm.newpassWord"></el-input>
              </el-form-item>
              <el-form-item prop="confirmpassWord">
                <el-input type="passWord" placeholder="请再次输入新密码" prefix-icon="iconfont icon-mimasuo"
                  v-model="setForm.confirmpassWord"></el-input>
              </el-form-item>
              <el-row style="margin-top:42px;">
                <el-button type="primary" @click="complete">完成</el-button>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
const TIME_COUNT = 60; //更改倒计时时间
import { mapMutations } from "vuex";
import {
  getRequestCode,
  AutoLogin,
  checkToken,
  userOutLogin,
  userLogin,
  getUserImg
} from "../api/api.js";
export default {
  name: "App",
  data() {
    return {
      activeIndex: "0",
      userInfo: {
        userIcon: require("../assets/images/infoimg1.png"),
        name: "熏悟空"
      },
      parkToken: "",
      loginDialog: false,
      isLoading: false,
      parkbigscreenToken: "",
      loadText: "登录中",
      loginForm: {
        name: "",
        pwd: "",
        saveme: false
      },
      phoneLoginForm: {
        phone: "",
        verificationCode: ""
      },
      forgetForm: {
        phone: "",
        verificationCode: ""
      },
      setForm: {
        newpassWord: "",
        confirmpassWord: ""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }
        ],
        pwd: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur"
          }
        ]
      },
      phoneLoginFlag: true,
      loginFlag: false,
      forgetPassFlag: false,
      resetPassFlag: false,

      //验证码按钮
      show: true, // 初始启用按钮
      count: "", // 初始化次数
      timer: null,
      imgPath: ""
    };
  },
  created() { },
  mounted() {
    this.parkToken = localStorage.getItem("parkToken");
    this.userInfo.name = localStorage.getItem("parkusername");
    this.check();
    document.documentElement.scrollTop = document.body.scrollTop = 0;
    this.toGetUserImg();
  },
  methods: {
    ...mapMutations([
      "parkLogin",
      "parkName",
      "parkType",
      "parkMenuid",
      "parkTokentime",
      "updateTokenStatus"
    ]),
    toGetUserImg() {
      let _this = this;
      let params = {
        StrJson: JSON.stringify({})
      };
      getUserImg(params)
        .then(function (response) {
          let res = response.data;
          if (res.code == 1) {
            if (res.data) {
              _this.imgPath = res.data;
            } else {
              _this.imgPath = require("../assets/images/default.png");
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    check() {
      let _this = this;
      if (_this.parkToken) {
        let params = {
          Code: _this.parkToken,
          UrlCode: this.$route.query.code
        };
        checkToken(params)
          .then(function (response) {
            let res = response.data;
            if (res.code == 1) {
              var result = res.data.result;
              if (result == 1) {
                _this.del_User();
              }
              if (result == 3) {
                //console.log('进入3');
                Promise.all([_this.del_User()]).then(res => {
                  //console.log('进入pro');
                  _this.IsAutoLogin();
                });
              }
            } else {
              // if (res.code == -10) {
              //   this.commonTipsError(res.result);
              // } else {
              this.commonTipsError("授权失败");
              //}
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        _this.IsAutoLogin();
      }
    },
    //点击全屏
    screen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    del_User() {
      let _this = this;
      return new Promise((resolve, reject) => {
        let params = {};
        userOutLogin(params)
          .then(function (response) {
            let res = response.data;
            if (res.code == 1 || res.code == -2) {
              localStorage.removeItem("parkToken");
              localStorage.removeItem("parkusername");
              localStorage.removeItem("parktype");
              localStorage.removeItem("parkmenuid");
              localStorage.removeItem("parkTokenTime");
              _this.updateTokenStatus(false);
              _this.parkToken = "";
              //_this.commonTipsSuccess("退出成功~");
              window.location.href = _this.$config.Home.pageUrl + "/login";
            } else {
              _this.commonTipsError(res.result);
            }
            setTimeout(() => {
              _this.toGetUserImg();
            }, 1000);
            resolve(resolve);
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    },
    GetCode(SysId, url) {
      let params = {
        SystemId: SysId
      };
      debugger;
      var parkToken = localStorage.getItem("parkToken");

      if (!parkToken) {
        //直接跳转http
        window.location.href = url;
      } else {
        getRequestCode(params)
          .then(function (response) {
            let res = response.data;
            if (res.code == 1) {
              //console.log('');
              window.location.href = url + "?code=" + res.data;
            } else {
              // if (res.code == -10) {
              //   this.commonTipsError(res.result);
              // } else {
              this.commonTipsError("授权失败");
              //}
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    IsAutoLogin() {
      let _this = this;
      var parkToken = localStorage.getItem("parkToken");
      var Code = this.$route.query.code;
      if (!parkToken && Code) {
        let params = {
          Number: Code
        };
        AutoLogin(params)
          .then(function (response) {
            let res = response.data;
            if (res.code == 1) {
              //_this.commonTipsSuccess("授权成功");
              // 获取到当前时间,转换成JSON字符串序列
              let curtime = JSON.stringify(new Date().getTime());
              // 将用户token保存到vuex中,将当前时间保存
              _this.parkLogin({
                parkToken: res.data.loginToken
              });
              _this.parkTokentime({
                parkTokenTime: curtime
              });
              _this.parkName({
                parkusername: res.data.name
              });
              _this.parkToken = res.data.loginToken;
              _this.userInfo.name = res.data.name;
              _this.updateTokenStatus(true);
            } else {
              // if (res.code == -10) {
              //   this.commonTipsError(res.result);
              // } else {
              //this.commonTipsError("授权失败");
              //}
            }
            setTimeout(() => {
              _this.toGetUserImg();
            }, 1000);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getLogin() {
      let _this = this;
      return new Promise((resolve, reject) => {
        _this.$refs["loginForm"].validate(valid => {
          if (valid) {
            let params = qs.stringify({
              Phone: _this.loginForm.name,
              PassWord: _this.loginForm.pwd,
              Type: 1
            });
            _this.isLoading = true;
            _this.$http
              .post("/Api/Login", params)
              .then(function (response) {
                let res = response.data;
                _this.loading = false;
                if (res.code == 1) {
                  let curtime = JSON.stringify(new Date().getTime());
                  // 将用户token保存到vuex中,将当前时间保存
                  _this.parkLogin({
                    parkToken: res.data.loginToken
                  });
                  _this.parkTokentime({
                    parkTokenTime: curtime
                  });
                  _this.parkName({
                    parkusername: res.data.name
                  });
                  _this.parkToken = res.data.loginToken;
                  // _this.parkType({
                  //     parktype: res.data.type
                  // });
                  // _this.parkMenuid({
                  //     parkmenuid: res.data.menuId
                  // });
                  //_this.commonTipsSuccess("登录成功~");
                  _this.userInfo.name = res.data.name;
                  //JumpPage('index', _this);
                  _this.updateTokenStatus(true);
                  _this.isLoading = false;
                  _this.loginDialog = false;
                } else {
                  _this.loading = false;
                  _this.isLoading = false;
                  _this.commonTipsError(res.result);
                }
                setTimeout(() => {
                  _this.toGetUserImg();
                }, 1000);
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        });
      });
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    //点击登录按钮登录
    selfLogin() {
      // this.loginDialog = true;
      // this.loginForm = {
      //     name: '',
      //     pwd: ''
      // }

      this.$router.push({
        name: "login"
      });
    },
    //注册
    register() {
      console.log("zhuce");
    },
    async submitForm() {
      let _this = this;
      return new Promise((resolve, reject) => {
        //   if(_this.loginForm.saveme){
        //     localStorage.setItem('parklogin', JSON.stringify(_this.loginForm));
        //   }
        _this.$refs["phoneLoginForm"].validate(valid => {
          if (valid) {
            let params = {
              Phone: _this.phoneLoginForm.phone,
              PassWord: _this.phoneLoginForm.verificationCode
            };
            _this.loading = true;
            userLogin(params)
              .then(function (response) {
                let res = response.data;
                _this.loading = false;
                if (res.code == 1) {
                  // _this.getMenu();
                  // 获取到当前时间,转换成JSON字符串序列
                  let curtime = JSON.stringify(new Date().getTime());
                  // 将用户token保存到vuex中,将当前时间保存
                  _this.parkLogin({
                    parkToken: res.data.loginToken
                  });
                  _this.parkTokentime({
                    parkTokenTime: curtime
                  });
                  _this.parkName({
                    parkusername: res.data.name
                  });
                  _this.parkType({
                    parktype: res.data.type
                  });
                  _this.parkMenuid({
                    parkmenuid: res.data.menuId
                  });
                  //_this.commonTipsSuccess("登录成功~");
                  JumpPage("index", _this);
                  _this.updateTokenStatus(true);
                } else {
                  _this.commonTipsError(res.result);
                }
              })
              .catch(function (error) {
                console.log(error);
              });
          }
        });
      });
    },
    forgetPass: function () {
      this.loginFlag = false;
      this.forgetPassFlag = true;
    },
    //获取验证码
    getVeriCode() {
      let _this = this;
      _this.send();
      // this.$refs.forgetForm.validate(valid => {
      //   if (valid) {
      //     let params = {
      //       Phone: _this.forgetForm.phone
      //     };
      //     _this.loading = true;
      //     getVeriCode(params)
      //       .then(function(response) {
      //         let res = response.data;
      //         if (res.code == 1) {
      //           _this.send();
      //           _this.commonTipsSuccess("短信发送成功，请注意查收");
      //           _this.loading = false;
      //         }
      //         _this.loading = false;
      //       })
      //       .catch(function(error) {
      //         console.log(error);
      //       });
      //   }
      // });
    },
    send() {
      if (!this.timer) {
        this.$refs.phoneLoginForm.validate(valid => {
          if (valid) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer); // 清除定时器
                this.timer = null;
              }
            }, 1000);
          }
        });
      }
    },
    returnLogin: function () {
      (this.phone = ""), (this.verificationCode = ""), (this.loginFlag = true);
      this.forgetPassFlag = false;
    },

    complete: function () {
      this.updatePass("setForm");
    },
    //根据手机号，验证码修改密码
    updatePass(formName) {
      let _this = this;
      _this.$refs[formName].validate(valid => {
        if (valid) {
          let params = {
            Phone: _this.forgetForm.phone,
            Code: _this.forgetForm.verificationCode,
            PassWord: _this.setForm.newpassWord
          };
          _this.loading = true;
          forgetUserPwd(params)
            .then(function (response) {
              let res = response.data;
              if (res.code == 1) {
                _this.commonTipsSuccess("修改成功，请重新登录~");
                _this.loading = false;
                _this.forgetPassFlag = false;
                _this.resetPassFlag = false;
                _this.loginFlag = true;
              }
              _this.loading = false;
            })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          _this.commonTipsError(res.result);
          return false;
        }
      });
    },
    //切换登录方式
    toggleLogin(type) {
      if (type == 1) {
        let model = {
          name: "",
          pwd: "",
          saveme: false
        };
        this.loginForm = model;
        this.phoneLoginFlag = true;
        this.loginFlag = false;
        this.forgetPassFlag = false;
        this.resetPassFlag = false;
      } else {
        let model = {
          phone: "",
          verificationCode: ""
        };
        this.phoneLoginForm = model;
        this.phoneLoginFlag = false;
        this.loginFlag = true;
        this.forgetPassFlag = false;
        this.resetPassFlag = false;
      }
    },
    //首页点击logo
    goIndex() {
      // window.location.reload();
      this.$router.push({
        name: "main"
      });
      window.scrollTo(0, 0);
    },
    //点击下拉菜单
    handleCommand(command) {
      if (command == "exit") {
        this.del_User();
      } else if (command == "personal") {
        this.$router.push({
          path: "/personalcenter"
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/index.vue